var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSapphire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444.44 369.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-111 {\r\n        fill: url(#linear-gradient111);\r\n      }\r\n\r\n      .cls-211 {\r\n        fill: url(#linear-gradient-211);\r\n      }\r\n\r\n      .cls-311 {\r\n        fill: url(#linear-gradient-311);\r\n      }\r\n\r\n      .cls-411 {\r\n        fill: url(#linear-gradient-411);\r\n      }\r\n\r\n      .cls-511 {\r\n        fill: url(#linear-gradient-511);\r\n      }\r\n\r\n      .cls-611 {\r\n        fill: url(#linear-gradient-611);\r\n      }\r\n\r\n      .cls-711 {\r\n        fill: url(#linear-gradient-711);\r\n      }\r\n\r\n      .cls-811 {\r\n        fill: url(#linear-gradient-811);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient111",
    y1: 184.54,
    x2: 444.44,
    y2: 184.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81749e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f7f6c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f1f3c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e0ead4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c4dbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#bfd8eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b699c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85899c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 40.84,
    y1: 99.14,
    x2: 141.74,
    y2: 99.14,
    xlinkHref: "#linear-gradient111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 98.01,
    y1: 47.78,
    x2: 345.87,
    y2: 47.78,
    xlinkHref: "#linear-gradient111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-411",
    x1: 142.41,
    y1: 111.46,
    x2: 301.63,
    y2: 111.46,
    xlinkHref: "#linear-gradient111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-511",
    x1: 302.34,
    y1: 99.12,
    x2: 404.16,
    y2: 99.12,
    xlinkHref: "#linear-gradient111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-611",
    x1: 42.89,
    y1: 212.59,
    x2: 199.19,
    y2: 212.59,
    xlinkHref: "#linear-gradient111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-711",
    x1: 144.86,
    y1: 236.88,
    x2: 299.15,
    y2: 236.88,
    xlinkHref: "#linear-gradient111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-811",
    x1: 244.14,
    y1: 213,
    x2: 402.18,
    y2: 213,
    xlinkHref: "#linear-gradient111"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M221.28,369.07h0c-.49,0-1,0-1.47-.05h-.06l-.4,0-1-.11-.55-.08c-.28,0-.58-.09-.91-.16l-.42-.08-.08,0c-.45-.1-.91-.22-1.35-.35l-.47-.14-.87-.29-.45-.17h0c-.29-.11-.58-.23-.86-.36h0l-.46-.21h0c-.32-.14-.64-.3-1-.46l-.31-.16c-.4-.22-.8-.45-1.21-.71l-.09-.05-.32-.21c-.27-.18-.54-.36-.8-.55l-.32-.23-.06-.05-.77-.6c-.11-.09-.21-.17-.3-.26l-.06-.05c-.36-.3-.69-.61-1-.92l-.27-.27c-.25-.25-.5-.51-.73-.77s-.2-.22-.3-.33l-.4-.47L5.13,119.8A22.37,22.37,0,0,1,5.35,91l.2-.23.22-.22L59.91,36.22A22.39,22.39,0,0,1,69.12,30l69.8-28.62.2-.07A22.26,22.26,0,0,1,146.52,0H296.23a22.17,22.17,0,0,1,7.4,1.26l.2.07,69.7,26.52A22.36,22.36,0,0,1,382.71,34l53.48,54.35a18.21,18.21,0,0,1,6.54,7.72c3,6.71,2,14.83-2.83,22.25l-.51.79-.3.36L238.5,361l-.39.45-.27.31-.68.72-.33.31c-.32.32-.67.64-1,.94l-.35.29c-.26.22-.52.42-.78.62l-.34.24c-.29.21-.57.4-.86.59l-.38.24a21,21,0,0,1-2.48,1.33l-.42.19c-.29.13-.59.25-.89.36s-.32.13-.49.18l-.87.3-.5.15c-.44.12-.89.24-1.34.34l-.47.09c-.32.07-.64.12-1,.17l-.47.07-1,.11-.5,0C222.2,369.06,221.74,369.07,221.28,369.07ZM225,352.51l3,4.55-3.21-5,.16.25-.16-.25.26-.18.08-.06a2.23,2.23,0,0,0,.24-.19l.1-.08.29-.26.09-.09a2.09,2.09,0,0,0,.2-.22l.08-.08.06-.07,0-.05L426.54,109.67v0c1.76-2.7,2.4-5.39,1.67-7a2.34,2.34,0,0,0-1-1.1l-.94-.55L371,44.87l-.16-.18a6.37,6.37,0,0,0-2.73-1.84l-.2-.08-69.67-26.5a6.48,6.48,0,0,0-2-.34H146.52a6.36,6.36,0,0,0-2,.32L74.8,44.84l-.2.07a6.36,6.36,0,0,0-2.78,1.9l-.2.24-.22.22L17.33,101.56a6.44,6.44,0,0,0,.09,8.1L216.29,350.79l.08.09,0,.06.08.08c.06.08.14.15.21.23l.08.08.28.25.11.09.22.17,0,0,.09.07.24.16.11.07c.12.08.24.14.35.2l.07,0,.28.14h0l.08,0,.05,0,.25.11h0l.11,0,.25.08.12,0,.41.11H220l.27.05.16,0,.29,0h.11a4.71,4.71,0,0,0,.84,0h.14l.31,0,.14,0,.26-.05.13,0,.39-.1.08,0,.05,0,.26-.09.14-.05.26-.11h0l.09,0a6,6,0,0,0,.71-.38l.08-.05,0,0,0,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "126.72 138.27 141.74 79.12 82.56 60.02 40.84 100.6 126.72 138.27"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-311",
    points: "152.19 65.75 291.89 65.75 345.87 48.22 293.32 29.81 150.66 29.81 98.01 48.26 152.19 65.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-411",
    points: "301.63 141.23 286.55 81.68 157.53 81.68 142.41 141.23 301.63 141.23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-511",
    points: "317.33 138.32 404.16 100.61 361.43 59.92 302.33 79.11 317.33 138.32"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-611",
    points: "126.37 155.51 42.89 118.9 199.19 306.29 126.37 155.51"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-711",
    points: "299.15 157.17 144.86 157.17 221.86 316.58 299.15 157.17"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-811",
    points: "317.65 155.55 244.14 307.15 402.18 118.84 317.65 155.55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapphire);
export default __webpack_public_path__ + "static/media/sapphire.1cc4faa1e2579d2676a77c471970e1cd.svg";
export { ForwardRef as ReactComponent };